import React, { useEffect, useState } from "react";
import Button from "../../common/Button/Button";
import Select from "../../common/Select/Select"
import api from "../../../services/api"
import { toast, ToastContainer } from "react-toastify";
import styles from "../../../pages/Grievances/AddGrievances.module.css";

const AddGrievanceResponse = ({ complaintId, onSubmitted, onCancel }) => {

    const [learningModules, setLearningModules] = useState([]);
    const [chapters, setChapters] = useState([]);
    const [formData, setFormData] = useState({
        response: "",
        complaintstatus: "",
        closuretext: "",
        attachment: null,
    });

    useEffect(() => {
        api.get('/learningmodules')
            .then((response) => {
                setLearningModules(response.data);
            })
            .catch((error) => {
                console.error('Error fetching learning modules:', error);
            });
    }, []);

    useEffect(() => {
        api.get('/chaptermaster')
            .then((response) => {
                setChapters(response.data);
            })
            .catch((error) => {
                console.error('Error fetching chapter data:', error);
            });
    }, []);

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name !== "attachment") {
            setFormData((prev) => ({ ...prev, [name]: value }));
            return;
        }

        const file = files?.[0];
        if (!file) return;

        const MAX_SIZE = 5 * 1024 * 1024; // 5MB

        const ext = file.name.split(".").pop().toLowerCase();

        const allowedExtensions = [
            "jpg", "jpeg", "png", "gif", "webp",
            "pdf",
            "txt",
            "doc", "docx",
            "zip", "rar"
        ];

        if (file.size > MAX_SIZE) {
            toast.error("❌ File size must be under 5MB");
            e.target.value = "";
            return;
        }

        if (!allowedExtensions.includes(ext)) {
            toast.error("❌ Unsupported file type");
            e.target.value = "";
            return;
        }

        setFormData((prev) => ({ ...prev, [name]: file }));
    };

    const handleClearAttachment = () => {
        setFormData((prev) => ({ ...prev, attachment: null }));
        document.getElementById("attachmentInput").value = "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const userId = localStorage.getItem("userId");
        const userRes = await api.get(`/users/${userId}`);
        const userName = userRes.data.name;

        const form = new FormData();
        Object.entries(formData).forEach(([key, value]) => value && form.append(key, value));

        form.append("userId", userId);
        const now = new Date();
        const responseDate = now.toISOString().split("T")[0];
        const closedDate = now.toISOString().split("T")[0];
        const responseTime = now.toTimeString().split(" ")[0];
        const closedTime = now.toTimeString().split(" ")[0];

        form.append("responseDate", responseDate);
        form.append("responseTime", responseTime);
        form.append("closedDate", closedDate);
        form.append("closedTime", closedTime);
        form.append("respondedBy", userName);
        form.append("closedBy", userName);
        form.append("complaintId", complaintId);

        api.post(`/grievanceresponse`, form)
            .then(() => {
                toast.success("Response submitted successfully!");
                if (onSubmitted) {
                    setTimeout(onSubmitted, 1200);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
                toast.error("Failed to submit response!");
            });
    };

    return (
        <div>
            <ToastContainer position="bottom-right" autoClose={2000} style={{ zIndex: 999999 }} />
            <form onSubmit={handleSubmit}>

                {/* Response Textarea (Full Width) */}
                <div className={styles.inputGroupFull} style={{ marginBottom: '14px' }}>
                    <label>Response</label>
                    <textarea
                        type="text"
                        name="response"
                        value={formData.response}
                        onChange={handleChange}
                        required
                    />
                </div>

                {/* Row for Select, Closure Text, and Attachment */}
                <div className={styles.row}>
                    <div className={styles.inputGroup}>
                        <label>Complaint Status</label>
                        <Select
                            required
                            placeholder="Select Status"
                            name="complaintstatus"
                            value={formData.complaintstatus || ""}
                            onChange={handleChange}
                            options={[
                                { value: "Opened", label: "Opened" },
                                { value: "Closed", label: "Closed" }
                            ]}
                        />
                    </div>
                    
                    <div className={styles.inputGroup}>
                        <label>Closure Text</label>
                        <input
                            type="text"
                            name="closuretext"
                            value={formData.closuretext}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className={styles.inputGroup}>
                        <label className="optional">
                            Attachment (Optional)
                            <span style={{ fontSize: "12px", color: "#FF0000" }}>
                                {" "} (Max 5MB • Image, PDF, Txt, Word, Zip, Rar)
                            </span>
                        </label>

                        <input
                            id="attachmentInput"
                            type="file"
                            name="attachment"
                            onChange={handleChange}
                            accept="
                                image/*,
                                application/pdf,
                                text/plain,
                                application/msword,
                                application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                .zip,
                                .rar
                            "
                        />
                        {formData.attachment && (
                            <div className={styles.attachmentPreview}>
                                <span>{formData.attachment.name}</span>
                                <button type="button" onClick={handleClearAttachment}>
                                    Clear
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <div className={styles.buttonGroup}>
                    <button type="submit" className={styles.submitBtn}>
                        Submit
                    </button>
                    <button type="button" onClick={onCancel} className={styles.backBtn}>
                        Cancel
                    </button>
                </div>

            </form>

        </div>
    );
};

export default AddGrievanceResponse;
